<template>
	<div class="rootDiv">
		<div class="fc-6b9eff fs-16 pointer">
			<div class="mr-30 flex flex-ac ml-30">
				<span class="fs-16 flex1 mr-20">商户单号：</span>
				<el-input placeholder="请输入商户号" v-model="outTradeNo" clearable class="w-450"></el-input>
				<el-button type="primary" @click="sendOrderMsg" class="ml-30">发送微信发货通知</el-button>
			</div>
			<el-button type="primary" class="ml-30 mt-30"  @click="saleOrder">刷新账单</el-button>
			<TableHeightFull class="tableDiv pall-30">
				<!-- 表格 -->
				<EleTable ref="tableRef" slot="table" :tableData="orderList" :columns="columns" height="100%" :border="false"
					v-loading="tabLoading" :row-style="{ cursor: 'pointer' }">
				</EleTable>
				<!-- 分页 -->
				<PagingComponent slot="after" :page-info="pageInfo" @getTableData="saleOrder" />
			</TableHeightFull>
		</div>
	</div>
</template>
<script>
	import indexMixin from "@/utils/indexMixin"
	export default {
		name: 'soldOrder',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
		},
		data() {
			return {
				orderList: [],
				columns: [{
					label: '订单时间段',
					prop: 'saleTime',
					align: 'left',
				}, {
					columnType: 'button',
					label: '操作',
					align: 'right',
					fixed: 'right',
					width: '420',
					buttons: [{
						type: 'text',
						text: '导出',
						fn: this.handleReclaim
					}]
				}],
				isDataLoaded: false,
				tabLoading: false,
				outTradeNo: ''
			}
		},
		mounted() {
			console.log(this, 'this')
			this.saleOrder()
		},
		methods: {
			saleOrder() {
				this.tabLoading = true
				this.$http.get('/saleOrder/findSaleOrderList', {
					params: {
						currentPage: this.pageInfo.pageNum,
						pageSize: this.pageInfo.pageSize,
					}
				}).then(res => {
					this.tabLoading = false
					this.pageInfo.total = res.data.data.total
					this.orderList = res.data.data.list
					this.isDataLoaded = true
				})
			},
			sendOrderMsg() {
				if (this.outTradeNo) {
					this.$http.post('tradingOrder/sendOrderMsgByOutTradeNo', {
						outTradeNo: this.outTradeNo
					}).then(res => {
						this.$message({
							message: '发送成功',
							type: 'success'
						})
						this.outTradeNo = ''
					}).catch(err => {})
				} else {
					this.$message({
						message: '请输入商户号',
						type: 'error'
					})
				}
			},
			//导出
			handleReclaim(row){
				this.$http.get('saleOrder/downloadSale',{
					params:{
						id:row.id
					}
				}, {
        responseType: "blob", // 1.首先设置responseType对象格式为 blob:
      }).then(res=>{
				let blob = new Blob([res.data], {
				  type: "application/vnd.ms-excel",
				})
				// 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
				let url = window.URL.createObjectURL(blob) // 3.创建一个临时的url指向blob对象
				// 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
				let a = document.createElement("a")
				a.href = url
				a.download = "预售账单.txt"
				a.click()
				// 5.释放这个临时的对象url
				window.URL.revokeObjectURL(url)
			})
			},
			sizeChange() {
				this.pageInfo.pageNum = 1
				this.saleOrder()
			},
			currentChange() {
				this.saleOrder()
			},
		}
	}
</script>
<style>
</style>